import supabase from "@/lib/supabaseClient";
import {store} from "@/store";
import { Loader } from "@googlemaps/js-api-loader";

export const allMixins = {
    data() {
        return {
            mapOptions: null,
            loader: null,
            map: null,
            service: null,
        };
    },
    created() {
        this.initialize()
    },
    methods: {
        initialize() {
             const loader = new Loader({
                apiKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
                version: "weekly",
                libraries: ["places"]
            });

            this.mapOptions = {
                center: {
                    lat: 0,
                    lng: 0
                },
                zoom: 4
            };
            loader.load().then((google) => {
                this.map = new google.maps.Map(document.createElement("map"), {
                    center: { lat: -34.397, lng: 150.644 },
                    zoom: 8
                });

                this.service = new google.maps.places.PlacesService(this.map);
            });
        },
        async updateStayDepartureDate(stayId, departureDate, updateTense) {
            const { data, error } = await supabase
                .from("stays")
                .update({ departure_date: departureDate, last_updated: new Date() , tense: updateTense})
                .eq("id", stayId);

            if (error) {
                console.error("Error updating stay departure date:", error);
                return;
            }
            console.log("Updated stay departure date:", data);
        },
        async checkRowExistence(idToCheck) {
            const { count, error } = await supabase
                .from('locations')
                .select('*', { count: 'exact', head: true })
                .eq('id', idToCheck);
            if (error) {
                console.error('Error checking row existence:', error);
                return false; // Handle the error as needed
            }
            return count >= 1;
        },
        async getPlaceDetails(placeId) {
            const request = {
                placeId
            };

            return new Promise((resolve, reject) => {
                this.service.getDetails(request, (place, status) => {
                    if (status === 'OK') {
                        resolve(place);
                    } else {
                        reject(status);
                    }
                });
            });
        },
        async createLocation() {
            let googlePicUrl = null;
            if (this.existingPlace) {
                console.log(this.existingPlace)
                const alreadyExists = await this.checkRowExistence(this.existingPlace.place_id)
                if (alreadyExists) {
                    console.log('location exists')
                    return true
                } else if (!this.existingPlace.photos) {
                    this.existingPlace = await this.getPlaceDetails(this.existingPlace.place_id)
                }
                this.existingPlace.photos.forEach((photo) => {
                        if (photo.html_attributions.length === 0) {
                            googlePicUrl = photo.getUrl()
                            this.picAtt = photo.html_attributions[0]
                        }
                    }
                )
                if (googlePicUrl === null) {
                    googlePicUrl = this.existingPlace.photos[0].getUrl()
                    this.picAtt = this.existingPlace.photos[0].html_attributions[0]
                }

                this.placePicUrl = process.env.VUE_APP_SUPABASE_URL + "/storage/v1/object/public/avatars/locationPics/" + `place_${this.existingPlace.place_id.trim()}.jpg`

                const marker = {
                    lat: this.existingPlace.geometry.location.lat(),
                    lng: this.existingPlace.geometry.location.lng()
                };

                this.center = marker;

                this.existingPlace.address_components.forEach((component) => {
                    if (component.types[0] === "country") {
                        this.locationCountry = component.long_name
                    }
                })
                this.locationName = this.existingPlace.name + ', ' + this.locationCountry;

                const { data, error } = await supabase
                    .from("locations")
                    .insert([
                        {
                            position: marker,
                            name: this.locationName,
                            pic_url: this.placePicUrl,
                            pic_att: this.picAtt,
                            id: this.existingPlace.place_id.trim()
                        }
                    ])

                if (error) {
                    console.error("Error inserting marker into 'locations' table:", error);

                }
                console.log("Marker inserted into 'locations' table:", data);

                const { functionData, functionError } = await supabase.functions.invoke('location-pic-replace', {
                    body: { placeId: this.existingPlace.place_id, picGoogleUrl: googlePicUrl},
                    method: 'POST'
                })
                console.log(functionData)
                if (functionError) {
                    console.error("Error in function:", functionError);
                } else {
                    console.log("good function:" + functionData);
                }
                return true
            }
        },

        async addLocationMarker() {
            if (this.existingPlace) {
                try {
                    let creatLocationSuccess = await this.createLocation()
                    if (!creatLocationSuccess) {
                        return false
                    }
                    if (this.stayDates[1]) {
                        this.stayDates.sort((a, b) => {
                            const dateA = new Date(a);
                            const dateB = new Date(b);
                            return dateA - dateB;
                        });
                    }

                    const { data, error } = await supabase
                        .from("stays")
                        .insert([
                            {
                                user_id: store.state.userData.userId,
                                arrival_date: this.stayDates[0],
                                departure_date: this.stayDates[1],
                                public: this.isPublicStay,
                                place_id: this.existingPlace.place_id,
                                tense: this.getDateTense(this.stayDates)
                            }
                        ])
                    if (error) {
                        console.error("Error inserting marker into 'stays' table:", error);
                        return;
                    }
                    console.log("Marker inserted into 'stays' table:", data);
                    return true
                } catch (error) {
                    store.commit("addLocationErrorAlertOn")
                    console.error("Error during addLocationMarker operation:", error);
                } finally {
                    this.placePicUrl = '',
                    this.picAtt = '',
                    this.locationName = '',
                    this.locationCountry = ''
                    this.stayDates = [new Date().toISOString().split('T')[0]];
                    this.autocompleteKey++
                }
            }
        },
        getDateTense(dateArray) {
            if (!Array.isArray(dateArray) || dateArray.length === 0) {
                return "Invalid input";
            }

            const currentDate = new Date();
            const startDate = new Date(dateArray[0]);

            if (dateArray[0] && !dateArray[1]) {
                const endDate = new Date("2100-01-01"); // Assume a far-future end date.

                if (startDate <= currentDate && endDate >= currentDate) {
                    return "present";
                } else if (startDate < currentDate) {
                    return "past";
                } else {
                    return "future";
                }
            } else if (dateArray[0] && dateArray[1]) {
                const endDate = new Date(dateArray[1]);
                endDate.setHours(23, 59, 59, 999);
                if (startDate <= currentDate && endDate >= currentDate) {
                    return "present";
                } else if (endDate < currentDate) {
                    return "past";
                } else {
                    return "future";
                }
            } else {
                return "invalid input";
            }
        },
    },
}
